import React from "react";
import { useSearchParams } from "react-router-dom";
import AllSexView from "./AllSexView.tsx";
import Typography from "../../components/typography/index.tsx";

/**
 * Результати пошуку. Бекенд уже фільтрує за назвою (products/filtered?search=),
 * тому окремого ендпоінта не треба -- це той самий AllSexView, що й категорії.
 */
const SearchView = () => {
  const [params] = useSearchParams();
  const q = (params.get("q") || "").trim();

  if (!q) {
    return (
      <Typography variant="h5" style={{ padding: "24px 8px" }}>
        ВВЕДІТЬ НАЗВУ ТОВАРУ
      </Typography>
    );
  }

  return <AllSexView search={q} title={`ПОШУК: ${q}`} />;
};

export default SearchView;
